// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconeCenter {
  width: 50px;
  height: 50px;
  color: var(--ion-color-primary);
}

.linelabelTitulo {
  padding-top: 0px;
  padding-bottom: 0px;
  font-weight: bold;
  font-size: 2vh;
  color: var(--ion-color-primary);
}

.linelabel {
  padding-top: 0px;
  padding-bottom: 0px;
  font-weight: normal;
  font-size: 2vh;
  color: var(--ion-color-primary);
}

.linelabelB {
  padding-top: 0px;
  padding-bottom: 0px;
  font-weight: bold;
  font-size: 4vh;
  color: var(--ion-color-primary);
}

.linelabelMini {
  padding-top: 0px;
  padding-bottom: 0px;
  font-weight: normal;
  font-size: 3vh;
  color: var(--ion-color-primary);
}

.Button_Liga {
  color: var(--ion-color-primary);
  font-weight: bold;
  font-size: 5vw;
  text-align: center;
  --background: var(--ion-color-secondary);
  --border-radius: 1vh 2vh 1vh 2vh;
  width: 55vw;
  height: 7vh;
  margin-top: 5px;
  margin-bottom: 0px;
  text-align: center;
  display: inline-block;
}

.Box-Card-Button-inner {
  margin-left: 0px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 20px;
  border: var(--ion-color-secondary);
  border-style: solid;
  border-width: 2px;
  padding: 0px;
  width: 15vh;
  height: 10vh;
  align-items: center;
  font-weight: bold;
  font-size: small;
}

.grid-Mens {
  padding: 0px;
  margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/component/modal-Mens/modal-Mens.component.scss"],"names":[],"mappings":"AAUA;EACI,WAAA;EACA,YAAA;EAGA,+BAAA;AAXJ;;AAaA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;AAVJ;;AAcA;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;AAXJ;;AAaA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;AAVJ;;AAYA;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;AATJ;;AAYA;EACI,+BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AATJ;;AAWE;EACE,gBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AARJ;;AAWA;EAEI,YAAA;EACA,WAAA;AATJ","sourcesContent":["// .butSair{\n//     // --padding-start: 0px;\n//     // --padding-end: 0px;\n//     // --padding-bottom: 0px;\n//     // --padding-top: 0px;\n//     // margin: 0px;\n//     // margin-right: 5px;\n//     // height: 5.5vh;\n//     // width: 9.6vw;\n// }\n.iconeCenter{\n    width: 50px;\n    height: 50px;\n    // padding-left: 10vh;\n    // padding-top:5.5vh;\n    color: var(--ion-color-primary);\n}\n.linelabelTitulo{\n    padding-top: 0px;\n    padding-bottom: 0px;\n    font-weight: bold;\n    font-size: 2vh;\n    color: var(--ion-color-primary);\n    // padding-right: 15px;\n    // padding-left: 15px;\n}\n.linelabel{\n    padding-top: 0px;\n    padding-bottom: 0px;\n    font-weight: normal;\n    font-size: 2vh;\n    color: var(--ion-color-primary);\n}\n.linelabelB{\n    padding-top: 0px;\n    padding-bottom: 0px;\n    font-weight: bold;\n    font-size: 4vh;\n    color: var(--ion-color-primary);\n}\n.linelabelMini{\n    padding-top: 0px;\n    padding-bottom: 0px;\n    font-weight: normal;\n    font-size: 3vh;\n    color: var(--ion-color-primary);\n}\n\n.Button_Liga{\n    color: var(--ion-color-primary);\n    font-weight: bold;\n    font-size: 5vw;\n    text-align: center;\n    --background: var(--ion-color-secondary);\n    --border-radius: 1vh 2vh 1vh 2vh;\n    width: 55vw;\n    height: 7vh;\n    margin-top: 5px;\n    margin-bottom: 0px;\n    text-align: center;\n    display: inline-block;\n  }\n  .Box-Card-Button-inner {\n    margin-left: 0px;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 20px;\n    border-bottom-left-radius: 5px;\n    border-top-left-radius: 20px;\n    border: var(--ion-color-secondary);\n    border-style: solid;\n    border-width: 2px;\n    padding: 0px;\n    width: 15vh;\n    height: 10vh;\n    align-items: center;\n    font-weight: bold;\n    font-size: small;\n}\n\n.grid-Mens{\n   // border: 1px solid lightgrey;\n    padding: 0px;\n    margin: 0px;\n   // border-radius: 20px 0px 20px 0px;\n   // max-height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
